module.exports = __webpack_public_path__ + "img/Shopify_logo_2018.svg.7a0a520d.png";